// extracted by mini-css-extract-plugin
export default {"info":"EditImplant_info__d9ZyE","infoColumn":"EditImplant_infoColumn__+SQdn","implant":"EditImplant_implant__d6Q5A"};